import Toolbar from 'react-big-calendar/lib/Toolbar'
import message from 'react-big-calendar/lib/utils/messages'
import { navigate } from 'react-big-calendar/lib/utils/constants'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import $ from 'jquery'

import i18n from '@/i18n'

import Icon from '../Icons'
import Can from '../Can'
import { DEFAULT_TZ } from '../../constants/date'
import { getRangeInBuildingTz } from '../../helpers/helpers'
import { selectUserData } from '../../reducers/userDataReducer'
import { selectEndDate, selectStartDate, toggleActivities } from '../../reducers/trainingsReducer'
import { clearFilter, filterByEventType } from '../../reducers/filtersReducer'
import {
  getAmenities,
  getAmenityReservationsInDateRange,
  getMultiDayAmenityReservationsInDateRange,
} from '../../reducers/Organisation/reservationsReducer'
import { selectActiveBuilding } from '../../reducers/buildingSelectorReducer'
import withHookSnackbar from '../../helpers/hooks/hocUseSnackbar'

class CalendarToolbar extends Toolbar {
  constructor(props) {
    super(props)
    this.toggleActivities = this.toggleActivities.bind(this)
    this.renderManagerFilters = this.renderManagerFilters.bind(this)
    this.handleEventFilter = this.handleEventFilter.bind(this)
  }

  handleEventFilter(e, eventType) {
    e.preventDefault()
    const {
      buildingData,
      getAmenityReservationsInDateRange,
      getMultiDayAmenityReservationsInDateRange,
      getAmenities,
      startDate,
      endDate,
    } = this.props

    this.props.clearFilter('calendar', 'Class Type')
    this.props.filterByEventType('calendar', eventType)
    $(e.target).addClass('is-current').siblings().removeClass('is-current')
    $('.ctp-event-popup')
      .removeClass('ctp-event-popup--active')
      .removeClass('ctp-event-popup--pos-right')

    if (eventType === 'reservation' && buildingData) {
      const { start, end } = getRangeInBuildingTz(
        startDate,
        endDate,
        buildingData.timezone || DEFAULT_TZ,
      )

      getAmenityReservationsInDateRange(buildingData.id, start, end)
      getMultiDayAmenityReservationsInDateRange(buildingData.id, start, end)
      getAmenities(buildingData.id).catch(() =>
        this.props.displaySnackbar(i18n.t('calendar:errors.loadAmenities'), true),
      )
    }
  }

  renderManagerFilters() {
    return (
      <div className="ctp-toolbar__filters">
        <Can to={'seeToolbar'} on={'ManagerCalendar'}>
          <span className="rbc-btn-group">
            <button
              type="button"
              onClick={(e) => this.handleEventFilter(e, 'all')}
              className="is-current"
            >
              {i18n.t('calendar:toolbar.all')}
            </button>
            <button type="button" onClick={(e) => this.handleEventFilter(e, 'class')}>
              {i18n.t('calendar:toolbar.classes')}
            </button>
            <button type="button" onClick={(e) => this.handleEventFilter(e, 'appointment')}>
              {i18n.t('calendar:toolbar.appointments')}
            </button>
            <button type="button" onClick={(e) => this.handleEventFilter(e, 'event')}>
              {i18n.t('calendar:toolbar.events')}
            </button>
            <button type="button" onClick={(e) => this.handleEventFilter(e, 'reservation')}>
              {i18n.t('calendar:toolbar.reservations')}
            </button>
          </span>
        </Can>
      </div>
    )
  }

  renderPropertyManagerFilters() {
    return (
      <div className="ctp-toolbar__filters">
        <Can to={'seeToolbar'} on={'PM_FD_Calendar'}>
          <span className="rbc-btn-group">
            <button
              type="button"
              onClick={(e) => this.handleEventFilter(e, 'all')}
              className="is-current"
            >
              {this.props.userData.user && this.props.userData.user.role === 'PropertyManager'
                ? i18n.t('calendar:toolbar.social')
                : i18n.t('calendar:toolbar.all')}
            </button>
            <button type="button" onClick={(e) => this.handleEventFilter(e, 'event')}>
              {i18n.t('calendar:toolbar.events')}
            </button>
            <button type="button" onClick={(e) => this.handleEventFilter(e, 'reservation')}>
              {i18n.t('calendar:toolbar.reservations')}
            </button>
          </span>
        </Can>
      </div>
    )
  }

  toggleActivities() {
    this.props.toggleActivities()
  }

  render() {
    let { label, userData } = this.props
    // Note: react-big-calendar's core never passes a `messages` prop to the toolbar
    // component directly — only `localizer`, which has `messages` merged into it
    // (see react-big-calendar/lib/Calendar.js Calendar.getContext). Reading
    // `this.props.messages` here would always be undefined.
    const messages = message(this.props.localizer?.messages)
    return (
      <div className="rbc-toolbar ctp-toolbar calendar-toolbar">
        <span className="rbc-btn-group">
          <button
            type="button"
            className="ctp-toolbar__today"
            onClick={this.navigate.bind(null, navigate.TODAY)}
          >
            {messages.today}
          </button>
          <nav className="ctp-toolbar__navigation">
            <button
              type="button"
              className="ctp-toolbar__arrow"
              onClick={this.navigate.bind(null, navigate.PREVIOUS)}
            >
              <span>
                <Icon icon="arrow" />
              </span>
            </button>
            <button
              type="button"
              className="ctp-toolbar__arrow"
              onClick={this.navigate.bind(null, navigate.NEXT)}
            >
              <span>
                <Icon icon="arrow" />
              </span>
            </button>
          </nav>
        </span>
        <span className="rbc-toolbar-label">{label}</span>
        {this.renderManagerFilters()}
        {this.renderPropertyManagerFilters()}
        <span className="rbc-btn-group ctp-toolbar__views">
          {this.viewNamesGroup(messages)}
          {Object.prototype.hasOwnProperty.call(userData, 'user') &&
            userData.user.role === 'Client' && (
              <div className="ctp-toolbar__my-activties">
                <span>{i18n.t('calendar:toolbar.onlyMyBookings')}</span>
                <div>
                  <input
                    id="my-activities"
                    type="checkbox"
                    onChange={this.toggleActivities}
                    checked={this.props.trainings.onlyMyActivities}
                  />
                  <label htmlFor="my-activities" />
                </div>
              </div>
            )}
        </span>
      </div>
    )
  }
}

CalendarToolbar.propTypes = {
  userData: PropTypes.object,
  clearFilter: PropTypes.func,
  filterByEventType: PropTypes.func,
  getAmenityReservationsInDateRange: PropTypes.func,
  getMultiDayAmenityReservationsInDateRange: PropTypes.func,
  getAmenities: PropTypes.func,
  displaySnackbar: PropTypes.func,
  startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
  buildingData: PropTypes.object,
}

export default withHookSnackbar(
  connect(
    (state) => ({
      trainings: state.trainings,
      userData: selectUserData(state),
      buildingData: selectActiveBuilding(state),
      startDate: selectStartDate(state),
      endDate: selectEndDate(state),
    }),
    {
      toggleActivities,
      clearFilter,
      filterByEventType,
      getAmenities,
      getAmenityReservationsInDateRange,
      getMultiDayAmenityReservationsInDateRange,
    },
  )(CalendarToolbar),
)
